
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["h-5 w-5",classNames,staticClass],
              style: [{"padding-top":"1px"},style,staticStyle],
              attrs: Object.assign({"viewBox":"0 -2 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","style":"padding-top:1px"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"8.99938","cy":"5.67909","rx":"4.87111","ry":"4.67909","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.9994 16.9999C15.4349 14.1483 12.3551 12.3633 8.99939 12.3633C5.64368 12.3633 2.56391 14.1483 0.99939 16.9999","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    